import {defineStore} from 'pinia';
import {useRouter} from 'vue-router';
import {ref} from "vue";

import dbUtils from '@/utils/strotage.js'
import {authLogin, authLogout, getUserInfo} from "@/api/user";
import {AntdConfirm, AntdMessage} from "@/utils/toast";
import {getAllOptions} from "@/api/common";
import {md5} from "@/utils/md5";

export const useAuthStore = defineStore('auth', () => {
    let router = useRouter()

    // ref() 就是 state 属性
    const user = ref(null)
    const options = ref(null)

    // 登录
    async function login(username, password) {
        return new Promise((resolve, reject) => {
            authLogin({username: username, password: md5(password)}).then(res => {
                if (res.code === 200) {
                    user.value = null
                    options.value = null
                    AntdMessage.info('登录成功')
                    dbUtils.clear()
                    dbUtils.set(process.env.VUE_APP_TOKEN, res.data.token_type + ' ' + res.data.access_token);
                    const routeQuery = router.currentRoute.value.query || {}
                    router.replace(routeQuery && routeQuery.redirect || '/');   // 重定向
                } else {
                    reject(res)
                    AntdMessage.error(res.msg)
                }
            }).catch(err => {
                reject(err)
            })
        })
    }

    // 获取用户信息
    async function getUserDetail() {
        return new Promise((resolve, reject) => {
            getUserInfo().then(res => {
                if (res.code === 200) {
                    user.value = res.data  // 存储用户信息
                    dbUtils.set('menus', res.data.menus)  // 将菜单缓存
                    resolve()
                } else {
                    reject(res)
                    AntdMessage.error(res.msg)
                }
            }).catch(err => {
                reject(err)
            })
        })
    }

    // 退出登录
    async function logout() {
        AntdConfirm('你确定要退出登录吗?').then(ok => {
            if (ok) {
                authLogout().finally(async () => {
                    user.value = null
                    options.value = null
                    dbUtils.clear()  // 清除所有缓存
                    await router.replace('/login');   // 导航到登录页或其他适当的页面
                })
            }
        })
    }

    // 获取所有选项
    async function getOptionList() {
        return new Promise((resolve, reject) => {
            getAllOptions().then(res => {
                if (res.code === 200) {
                    options.value = res.data
                    resolve()
                } else {
                    reject(res)
                    AntdMessage.error(res.msg)
                }
            }).catch(err => {
                reject(err)
            })
        })
    }

    return {
        user,
        options,
        login,
        getUserDetail,
        logout,
        getOptionList,
    };
})
